import { render, staticRenderFns } from "./LiftDescription.vue?vue&type=template&id=1971b3ce&"
import script from "./LiftDescription.vue?vue&type=script&lang=js&"
export * from "./LiftDescription.vue?vue&type=script&lang=js&"
import style0 from "./LiftDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports